import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import NotificationPopUp from '../Headers/NotificationPopUp';
import ModalBase from '../ModalBase/ModalBase';
import HeaderFixed from './HeaderFixed';
import PracticeExamPopUp from './PracticeExamPopUp';
import Questions from './Questions';
import VPNModal from './VPNModal';
import WarfareModal from './WarfareModal';

class PracticeExamView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkPECalled: false,
      update: false,
      graded: false,
      firstRun: null,
      currentPage: 0,
      timerStarted: false,
      questionsLoaded: false,
      statusChecked: false,
      notAvailable: false,
      answersSetted: false,
      timer: this.props.timer,
      timerDisplay: '',
      resultsSummarized: props.resultsSummarized || [],
      showNotificationPopUp: false,
      notificationInformation: {
        mainButtonLabel: '',
        notificationTitle: '',
        notificationDescription: '',
        closeRedirect: '',
      },
      isCloseExamModal: false,
      showVPNModal: false,
      showWarfareModal: false,
      tenQuestion: [],
    };
    this.timer = null;
  }

  getNotificationInformation = (flag, userActive, isCustom) => {
    let notificationInformation;
    let showNotificationPopUp = false;
    if (userActive === true) {
      if (!isCustom) {
        if (flag === 'not-available') {
          notificationInformation = {
            closeRedirect: '/app/dashboard',
            mainButtonLabel: 'OK',
            notificationTitle: false,
            notificationDescription:
              'Retake any practice exam from the practice exam history.',
          };
          showNotificationPopUp = true;
        }
        if (flag === 'not-developed') {
          notificationInformation = {
            closeRedirect: '/app/dashboard',
            mainButtonLabel: 'SUPPORT',
            notificationTitle: false,
            notificationDescription:
              'Practice exam not available. Please contact customer support.',
          };
          showNotificationPopUp = true;
        }
      }
    } else {
      notificationInformation = {
        closeRedirect: '/app/dashboard',
        mainButtonLabel: 'MANAGE MY SUBSCRIPTION',
        notificationTitle: 'Subscription Expired',
        notificationDescription:
          'For full study access, renew your subscription.',
      };
      showNotificationPopUp = true;
    }

    this.setState({
      notificationInformation,
      showNotificationPopUp,
      showVPNModal: false,
    });
  };

  handleModalStatus = () => {
    this.setState({ isCloseExamModal: !this.state.isCloseExamModal });
  };

  notificationPopupMainAction = () => {
    switch (this.state.notificationInformation.mainButtonLabel.toLowerCase()) {
      case 'manage my subscription':
        history.push('/app/manage-subscription');
        break;
      case 'support':
        history.push('/support');
        break;
      default:
        history.push('/app/dashboard');
    }
  };

  openCancelPopUp = (value) => {
    this.setState({ showNotificationPopUp: value });
  };

  clearInterval = (timer) => {
    clearInterval(timer);
  };

  componentDidMount() {
    if (!this.props.reviewMode) {
      this.props.setPracticeExam(null);
      this.props.setResultsSummarized([]);
    }
    // Upon entering, we clear Redux and local (if it is not a review).
    if (!this.props.reviewMode) {
      this.props.setResultsSummarized && this.props.setResultsSummarized([]);
      this.setState({ resultsSummarized: [], answersSetted: false });
    }
  }

  componentWillUnmount() {
    this.clearInterval(this.timer);
    this.resetComponent();
  }

  getCurrentPageQuestionIds = () => {
    const list = this.state.tenQuestion || [];
    return list.map((q) => q?.id).filter(Boolean);
  };

  updateTimerPracticeExam = (timer) => {
    this.setState({ timer });

    const s = timer - 1;
    const h = Math.floor(s / 3600);
    const m = Math.floor(s / 60) - h * 60;
    const secs = Math.floor(s - m * 60 - h * 3600);
    this.setState({
      timerDisplay: `${h}:${m < 10 ? '0' : ''}${m}:${
        secs < 10 ? '0' : ''
      }${secs}`,
    });
  };

  setInterval = () => {
    const _this = this;
    return setInterval(() => {
      let timer = this.state.timer;
      if (timer > 0) {
        this.updateTimerPracticeExam(timer - 1);
      }
      timer -= 1;
      if (timer <= 1) {
        if (_this.props.practiceExam.id) {
          this.submitExam();
        }
        this.clearInterval(_this.timer);
      }
    }, 1000);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.timer !== this.props.timer || nextProps.reviewMode === true) {
      this.updateTimerPracticeExam(nextProps.timer);

      if (nextProps.timerStarted && !this.state.timerStarted) {
        this.setState({ timer: nextProps.timer }, () => {
          if (this.state.timer) {
            this.setState({ timerStarted: true });
            this.timer = this.setInterval();
            // reset history to update dashboard
            this.props.resetPracticeExamHistory();
          }
        });
      }
      if (
        !this.state.answersSetted &&
        Array.isArray(nextProps.resultsSummarized)
      ) {
        this.setState({
          resultsSummarized: nextProps.resultsSummarized || [],
          answersSetted: true,
        });
      }
    }

    if (nextProps.resultsSummarized !== this.state.resultsSummarized) {
      this.setState({ resultsSummarized: nextProps.resultsSummarized });
    }

    if (nextProps.submitPracticeExamSuccess) {
      this.clearInterval(this.timer);
      this.resetComponent();
      this.props.setSubmitPracticeExamSuccess(false);
      history.push('/app/practiceExamResults');
    }
    if (nextProps.user && !nextProps.userSubscription) {
      this.props.loadUserSubscription();
    }

    if (nextProps.user && nextProps.userSubscription) {
      if (!this.state.checkPECalled) {
        if (!nextProps.reviewMode && !nextProps.isLoading) {
          this.props.getWeeklyPracticeExams();
        } else {
          this.setState({ questionsLoaded: false });
        }
        if (!nextProps.userSubscription.warfarePlan)
          this.setState({ showVPNModal: true, showNotificationPopUp: false });
        if (nextProps.userSubscription.warfarePlan)
          this.setState({ showWarfareModal: true });
        this.setState({ checkPECalled: true });
      } else {
        if (
          nextProps.checkPracticeExamFlag.type &&
          !this.state.statusChecked &&
          !nextProps.checkPracticeExamLoading &&
          !nextProps.reviewMode &&
          !nextProps.retakeMode
        ) {
          if (
            nextProps.checkPracticeExamFlag.type === 'not-available' ||
            nextProps.checkPracticeExamFlag.type === 'not-developed'
          ) {
            this.setState(
              { firstRun: null, statusChecked: true, notAvailable: true },
              () => this.props.setCheckPracticeExamStatusFlag({ type: null }),
            );
          }
          if (nextProps.checkPracticeExamFlag.type === 'available') {
            this.setState(
              {
                firstRun: true,
                statusChecked: true,
                showVPNModal: true,
                showNotificationPopUp: false,
              },
              () => this.props.setCheckPracticeExamStatusFlag({ type: null }),
            );
          }
          if (
            nextProps.checkPracticeExamFlag.type === 'running' &&
            this.props.examQuestions.length > 0
          ) {
            this.setState({ firstRun: null, statusChecked: true }, () =>
              this.props.setCheckPracticeExamStatusFlag({ type: null }),
            );
          }
          const isCustom =
            history.location.state?.isCustom ||
            window.localStorage.getItem('isCustomPracticeExamChosen') ===
              'true';
          this.getNotificationInformation(
            nextProps.checkPracticeExamFlag.type,
            nextProps.user.active,
            isCustom,
          );
        }
      }
    }
  }

  resetComponent = () => {
    this.setState({
      checkPECalled: false,
      update: false,
      graded: false,
      firstRun: null,
      currentPage: 0,
      timerStarted: false,
      questionsLoaded: false,
      statusChecked: false,
      notAvailable: false,
      answersSetted: false,
      getQuestions: false,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.examQuestions.length > 0 && !this.state.questionsLoaded) {
      this.setState({ questionsLoaded: true });
      this.loadQuestions();
    }

    if (this.props.examQuestions?.length === 0) {
      if (this.props.practiceExam?.id && !this.state.getQuestions) {
        this.props.getPracticeExamQuestions(
          this.props.practiceExam.id,
          this.props.practiceExam.isCustom,
        );
        this.setState({
          getQuestions: true,
        });
      }
    }
  }

  loadQuestions = () => {
    const start = this.state.currentPage * 10;
    const end = start + 10;
    const questions = this.props.examQuestions;
    const tenQuestions = questions.slice(start, end);
    this.setState({ tenQuestion: tenQuestions });
  };

  submitExam = () => {
    this.props.setInitialTimePracticeExam(this.state.timer);
    this.props.setReviewMode(true);
    this.props.submitPracticeExam(
      this.props.practiceExam,
      this.state.resultsSummarized,
      this.props.practiceExam.isCustom,
    );
  };

  nextPage = () => {
    const { examQuestions } = this.props;
    const nextPage = this.state.currentPage + 1;
    // Filter by the 10 visible on THIS page
    const pageIds = this.getCurrentPageQuestionIds();
    const payload = (this.state.resultsSummarized || []).filter((d) =>
      pageIds.includes(d.question),
    );
    if (!this.props.reviewMode) {
      this.props.updatePracticeExamResults(
        this.props.practiceExam.id,
        payload,
        this.props.practiceExam.isCustom,
      );
    }
    this.setState({ currentPage: nextPage }, () => this.loadQuestions());
    window.scroll({ top: 0 });
  };

  previousPage = () => {
    const nextPage = this.state.currentPage - 1;
    const pageIds = this.getCurrentPageQuestionIds();
    const payload = (this.state.resultsSummarized || []).filter((d) =>
      pageIds.includes(d.question),
    );
    if (!this.props.reviewMode) {
      this.props.updatePracticeExamResults(
        this.props.practiceExam.id,
        payload,
        this.props.practiceExam.isCustom,
      );
    }
    this.setState({ currentPage: nextPage }, () => this.loadQuestions());
    window.scroll({ top: 0 });
  };

  launchExam = () => {
    this.setState({ firstRun: null });
    this.setState({ statusChecked: false });

    this.setState({ resultsSummarized: [], answersSetted: true });
    this.props.setResultsSummarized && this.props.setResultsSummarized([]);
    const isCustom =
      history.location.state?.isCustom ||
      window.localStorage.getItem('isCustomPracticeExamChosen') === 'true';
    if (isCustom) {
      if (history.location.state?.practiceExamId) {
        const practiceExamId = history.location.state.practiceExamId;
        this.props.startPracticeExam(null, practiceExamId, true);
      }
    } else if (!this.props.retakeMode) {
      if (history.location.state?.practiceExamId) {
        const practiceExamId = history.location.state.practiceExamId;
        this.props.startPracticeExam(null, practiceExamId);
      } else {
        history.push('/app/exams');
      }
    }
  };

  updateAnswer = (id_question, id_answer) => {
    const detail = { question: id_question, answer: id_answer };
    this.setNewDetail(detail);
  };

  setNewDetail = (detail) => {
    const currentDetails = [...(this.state.resultsSummarized || [])];
    if (currentDetails.length > 0) {
      const ExistingDetail = currentDetails.find(
        (d) => d.question === detail.question,
      );
      if (ExistingDetail) {
        const index = currentDetails.indexOf(ExistingDetail);
        currentDetails[index] = detail;
      } else {
        currentDetails.push(detail);
      }
    } else {
      currentDetails.push(detail);
    }

    this.setState({ resultsSummarized: currentDetails });
    this.props.setResultsSummarized &&
      this.props.setResultsSummarized(currentDetails);
  };

  exitExam = () => {
    this.props.setReviewMode(false);
    this.props.setRetakeMode(false);
    this.props.setPracticeExam(null);
    this.props.setExamQuestions([]);
    this.props.setResultsSummarized([]);
    history.push('/app/exams');
  };

  render() {
    const nextPage = this.state.currentPage + 1;
    const questionsPerPage = 10;
    const pageCount = Math.ceil(
      this.props.examQuestions.length / questionsPerPage,
    );
    let lastPage = false;
    let buttonLabel = 'Next Page';
    if (pageCount === nextPage) {
      lastPage = true;
      if (!this.props.reviewMode) {
        buttonLabel = 'SUBMIT EXAM';
      } else {
        buttonLabel = 'EXIT EXAM';
      }
    }
    let previousQuestionDisabled = false;
    let previousQuestionClass = 'secondary';

    if (nextPage === 1) {
      previousQuestionDisabled = true;
      previousQuestionClass = 'btn-outline-secondary disabled';
    }
    // send only the relevant question to the question parser
    const start = this.state.currentPage * 10 + 1;
    const end =
      this.props.examQuestions.length > start + 10
        ? start + 9
        : this.props.examQuestions.length;

    if (
      this.props.submitPracticeExamLoading ||
      this.props.isLoading ||
      this.props.checkPracticeExamLoading ||
      !this.state.checkPECalled
    ) {
      return (
        <div className="loading-gif-container">
          <CircularLoading className="loading-gif-waiting" />
        </div>
      );
    }

    if (!this.state.showNotificationPopUp || this.props.retakeMode === true) {
      if (this.state.showWarfareModal) {
        return (
          <WarfareModal
            open={this.state.showVPNModal}
            onStartExam={() => this.setState({ showWarfareModal: false })}
          />
        );
      }
      if (this.state.showVPNModal && !this.props.reviewMode)
        return (
          <VPNModal
            open={this.state.showVPNModal}
            onStartExam={() => this.setState({ showVPNModal: false })}
          />
        );
      const isCustom =
        history.location.state?.isCustom ||
        window.localStorage.getItem('isCustomPracticeExamChosen') === 'true';

      if (
        (this.state.firstRun && !this.props.retakeMode) ||
        (isCustom && !this.props.practiceExam)
      ) {
        if (
          this.props.checkPracticeExamLoading ||
          this.props.submitPracticeExamLoading ||
          this.props.isLoading
        ) {
          return (
            <div className="loading-gif-container">
              <CircularLoading className="loading-gif-waiting" />
            </div>
          );
        }
        const examToTake = isCustom
          ? this.props.customPracticeExam
          : {
              id: history.location.state?.practiceExamId,
              examTimeInMillis: history.location.state?.examTimeInMillis,
              amountQuestions: history.location.state?.amountQuestions,
            };

        return (
          <PracticeExamPopUp
            isOpen
            exam={examToTake}
            launchExam={this.launchExam}
            isCustom={isCustom}
          />
        );
      }

      if (this.props.practiceExam && this.state.checkPECalled) {
        return (
          <div className="question-main-body practice-exam">
            <HeaderFixed
              time={this.state.timerDisplay}
              start={start}
              end={end}
              total={this.props.examQuestions.length}
              exit={this.exitExam}
              reviewMode={this.props.reviewMode}
              handleModalStatus={this.handleModalStatus}
            />
            <Questions
              resultsSummarized={this.state.resultsSummarized}
              initialNumber={start}
              graded={this.props.reviewMode}
              questions={this.state.tenQuestion}
              answers={this.props.answers}
              updateAnswer={this.updateAnswer}
            />
            <br clear="all" />

            <div className="d-flex flex-row  justify-content-end bottom-buttons">
              <Button
                color="secondary"
                disabled={previousQuestionDisabled}
                className={previousQuestionClass}
                onClick={this.previousPage}
              >
                <i className="icon-chevron_left" /> Previous Page
              </Button>

              <Button
                data-test="next-page-button"
                color="secondary"
                className={
                  this.props.reviewMode && lastPage ? 'exit-button-red' : ''
                }
                onClick={
                  !lastPage
                    ? this.nextPage
                    : this.props.reviewMode
                      ? this.exitExam
                      : this.submitExam
                }
              >
                {buttonLabel}
                {!lastPage ? <i className="icon-chevron_right" /> : null}
              </Button>
            </div>
            <ModalBase
              isOpen={this.state.isCloseExamModal}
              className="modal-dialog-centered rating-exam-popup"
              header={
                <>
                  <i className="icon-close" onClick={this.handleModalStatus} />
                  Exit practice exam
                </>
              }
              body={
                <>
                  You can come back to this, but the exam timer will continue to
                  countdown. <br /> Are you sure you want to exit?
                </>
              }
              footer={
                <>
                  <button
                    className="btn modal-base-btn secondary"
                    onClick={this.handleModalStatus}
                  >
                    CANCEL
                  </button>
                  <button
                    className="btn modal-base-btn primary"
                    onClick={() => {
                      this.exitExam();
                    }}
                  >
                    CONFIRM
                  </button>
                </>
              }
            />
          </div>
        );
      }
    } else {
      if (!this.state.showVPNModal) {
        return (
          <NotificationPopUp
            isOpen={
              this.state.showNotificationPopUp &&
              !this.props.checkPracticeExamLoading
            }
            openCancelPopUp={this.openCancelPopUp}
            notificationInformation={this.state.notificationInformation}
            mainButtonFunction={this.notificationPopupMainAction}
            user={this.props.user}
          />
        );
      }
    }
  }
}

export default PracticeExamView;
